import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

export function DeleteConfirmDialog({
  open,
  onClose,
  onOpenChange,
  onConfirm,
  itemName = 'this item',
  itemType = 'item'
}) {
  const handleClose = onClose || (() => onOpenChange?.(false));
  return (
    <Dialog open={open} onOpenChange={(v) => !v && handleClose()}>
      <DialogContent className="bg-white/[0.02] border-white/[0.06] text-[#f0f0f5] max-w-sm">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: "'Playfair Display', serif" }}>
            Delete {itemType}?
          </DialogTitle>
          <DialogDescription className="text-[#b0b4c0] pt-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Are you sure you want to delete "{itemName}"? This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <div className="flex gap-3 mt-4">
          <Button 
            onClick={handleClose}
            variant="ghost" 
            className="flex-1 text-[#b0b4c0] hover:text-[#f0f0f5] rounded-full"
            data-testid="delete-cancel-btn"
          >
            Cancel
          </Button>
          <Button 
            onClick={() => { onConfirm(); handleClose(); }} 
            className="flex-1 bg-red-500/80 hover:bg-red-500 text-white rounded-full"
            data-testid="delete-confirm-btn"
          >
            Delete
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
